import React from 'react';
import { XCircle, AlertCircle } from 'lucide-react';

interface ErrorDisplayProps {
  error: Error | string;
  onRetry?: () => void;
  title?: string;
  variant?: 'inline' | 'full';
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  error,
  onRetry,
  title = 'Something went wrong',
  variant = 'inline',
}) => {
  const errorMessage =
    typeof error === 'string' ? error : error instanceof Error ? error.message : String(error);
  
  if (variant === 'full') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6 animate-fade-in">
          <div className="flex items-center mb-4">
            <XCircle className="w-8 h-8 text-danger-500 mr-3" />
            <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
          </div>
          <p className="text-gray-600 mb-4">{errorMessage}</p>
          {onRetry && (
            <button
              onClick={onRetry}
              className="w-full px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-all duration-200 transform hover:scale-105 font-medium"
            >
              Try Again
            </button>
          )}
        </div>
      </div>
    );
  }
  
  return (
    <div className="bg-danger-50 border-l-4 border-danger-500 p-4 rounded-lg animate-fade-in">
      <div className="flex items-start">
        <AlertCircle className="w-5 h-5 text-danger-500 mr-3 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-danger-800 mb-1">{title}</h3>
          <p className="text-sm text-danger-700">{errorMessage}</p>
          {onRetry && (
            <button
              onClick={onRetry}
              className="mt-3 text-sm font-medium text-danger-600 hover:text-danger-800 transition-colors"
            >
              Try Again →
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorDisplay;

